module.exports = __webpack_public_path__ + "img/love.5793a62c.png";